/* ============================================================
   TRUE SHADE SHOP — Luxury 3D interactions
   • Pointer-based 3D tilt on cards / tiles
   • Cinematic scroll-reveal
   • Hero spotlight follow
   Additive, dependency-free, degrades gracefully.
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouch = window.matchMedia('(hover: none)').matches;

  /* ---------- 1. 3D TILT ---------- */
  // Elements that should tilt toward the cursor.
  var TILT_SELECTOR = [
    '.product-card-wrapper .card',
    '.section-product-slider .card-wrapper .card',
    '.widget-services .service_inner'
  ].join(',');

  var MAX_TILT = 7; // degrees

  function applyTilt(el) {
    var frame = null;

    el.addEventListener('mousemove', function (e) {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = null;
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width;  // 0..1
        var py = (e.clientY - r.top) / r.height;  // 0..1
        var ry = (px - 0.5) * (MAX_TILT * 2);      // rotateY
        var rx = (0.5 - py) * (MAX_TILT * 2);      // rotateX
        el.style.setProperty('--ts-ry', ry.toFixed(2) + 'deg');
        el.style.setProperty('--ts-rx', rx.toFixed(2) + 'deg');
      });
    });

    el.addEventListener('mouseleave', function () {
      el.style.setProperty('--ts-ry', '0deg');
      el.style.setProperty('--ts-rx', '0deg');
    });
  }

  /* ---------- 2. HERO SPOTLIGHT FOLLOW ---------- */
  function initHeroSpotlight() {
    var heroes = document.querySelectorAll('.heroCarousel--item');
    heroes.forEach(function (hero) {
      hero.addEventListener('mousemove', function (e) {
        var r = hero.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        var content = hero.querySelector('.heroCarousel-content');
        if (content) {
          var dx = (x - 50) / 18;
          var dy = (y - 50) / 22;
          content.style.transform = 'translate3d(' + dx + 'px,' + dy + 'px,0)';
        }
      });
      hero.addEventListener('mouseleave', function () {
        var content = hero.querySelector('.heroCarousel-content');
        if (content) content.style.transform = '';
      });
    });
  }

  /* ---------- 3. SCROLL REVEAL ---------- */
  function initReveal() {
    var targets = document.querySelectorAll(
      '#MainContent .card-wrapper,' +
      '#MainContent .ss-section-collection-list-1 .item,' +
      '#MainContent .widget-services .service_inner,' +
      '#MainContent .section-video .item,' +
      '#MainContent .section-testimonals-list .item,' +
      '#MainContent .title.center,' +
      '#MainContent .sub-title.center'
    );
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (t) { t.classList.add('ts-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          var el = entry.target;
          // small stagger for grouped items
          el.style.transitionDelay = (Math.min(i, 6) * 60) + 'ms';
          el.classList.add('ts-in');
          obs.unobserve(el);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    targets.forEach(function (t) {
      t.classList.add('ts-reveal');
      io.observe(t);
    });
  }

  /* ---------- INIT ---------- */
  function init() {
    initReveal();

    if (reduceMotion || isTouch) return; // no tilt / parallax on touch or reduced-motion

    document.querySelectorAll(TILT_SELECTOR).forEach(applyTilt);
    initHeroSpotlight();

    // Re-bind for content injected later (Shopify theme editor, quick-add, sliders)
    if (window.MutationObserver) {
      var mo = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches(TILT_SELECTOR)) applyTilt(node);
            if (node.querySelectorAll) {
              node.querySelectorAll(TILT_SELECTOR).forEach(applyTilt);
            }
          });
        });
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor: re-init when sections reload
  document.addEventListener('shopify:section:load', function () {
    initReveal();
    if (!reduceMotion && !isTouch) {
      document.querySelectorAll(TILT_SELECTOR).forEach(applyTilt);
      initHeroSpotlight();
    }
  });
})();
